import { useMemo } from 'react'

import { TGetItemFn } from '@/config/types'
import { PageName } from '@/enums/pageName'

import { useAuth } from '@/auth/useAuth'

const FIRST_PAGE_INDEX = 0

const skipCheckList = [
  PageName.paymentSuccess,
  PageName.paymentFailed,
  PageName.verification,
  PageName.emailCollection,
  PageName.preLtp,
  PageName.ltpPaymentScreen,
  PageName.ltpPaymentFailed,
]

export const useCheckPageData = (
  pageName: PageName,
  pagesOrder: PageName[],
  getItem: TGetItemFn
) => {
  const { user } = useAuth()
  const currentPageIndex = useMemo(() => pagesOrder.indexOf(pageName), [pageName, pagesOrder])

  const firstPageName: PageName = pagesOrder[FIRST_PAGE_INDEX]
  const isFirstPage = currentPageIndex === FIRST_PAGE_INDEX

  const previousPageIndex = currentPageIndex - 1

  const lastPageName = (getItem('lastActionPage') as PageName) || firstPageName
  const lastVisitedPageIndex = useMemo(
    () => pagesOrder.indexOf(lastPageName),
    [lastPageName, pagesOrder]
  )

  const shouldSkip = useMemo(() => skipCheckList.indexOf(pageName) !== -1, [pageName])

  if (isFirstPage || shouldSkip) {
    return
  }

  const selectPlanData = getItem(PageName.selectPlan) || ''
  if (pageName === PageName.paymentScreen && !selectPlanData) {
    return PageName.selectPlan
  }

  const selectLTPData = getItem(PageName.selectLTP) || ''
  if (pageName === PageName.ltpPaymentScreen && !selectLTPData) {
    return PageName.selectLTP
  }

  const isRegistrationPage = pageName === PageName.registration
  const preparingPlanData = getItem(PageName.preparingPlan) || ''

  if (isRegistrationPage && lastVisitedPageIndex < previousPageIndex && !user) {
    return lastPageName || firstPageName
  }
  if (isRegistrationPage && preparingPlanData) {
    return
  }

  if (previousPageIndex <= lastVisitedPageIndex) {
    return
  }

  return lastPageName
}
